const SETTING_SET_OPERATORS = "SETTING_SET_OPERATORS"
const SETTING_SET_LEVEL_UMKD = "SETTING_SET_LEVEL_UMKD"
const SETTING_SET_DICT_DIRECTION_TRAINING = "SETTING_SET_DICT_DIRECTION_TRAINING"
const SETTING_SET_DICT_EDUCATIONAL_PROGRAM = "SETTING_SET_DICT_EDUCATIONAL_PROGRAM"

const SETTING_SET_GROUPS = "SETTING_SET_GROUPS"

const settingTypes = {
    SETTING_SET_OPERATORS,
    SETTING_SET_LEVEL_UMKD,

    SETTING_SET_DICT_DIRECTION_TRAINING,
    SETTING_SET_DICT_EDUCATIONAL_PROGRAM,

    SETTING_SET_GROUPS,
}

export default settingTypes